import { render, staticRenderFns } from "./CommentBlock.vue?vue&type=template&id=13a2415e"
import script from "./CommentBlock.vue?vue&type=script&lang=ts"
export * from "./CommentBlock.vue?vue&type=script&lang=ts"
import style0 from "./CommentBlock.vue?vue&type=style&index=0&id=13a2415e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports